<template>
  <rpm-read-more v-if="!edit" class="text-sm" :text="value || 'Sem resposta'"></rpm-read-more>

  <template v-else>
    <TextAnswer v-bind="$attrs" no-label v-if="type == 'text'" :question="original" />
    <EditorAnswer v-bind="$attrs" no-label v-else-if="type == 'editor'" :question="original" />
    <TextareaAnswer v-bind="$attrs" no-label v-else-if="type == 'textarea'" :question="original" />
  </template>
</template>

<script>

import RpmReadMore from "#components/RpmReadMore";
import TextAnswer from '#views/questionnaire/answers/TextAnswer';
import EditorAnswer from '#views/questionnaire/answers/EditorAnswer';
import TextareaAnswer from '#views/questionnaire/answers/TextareaAnswer';

export default {
  name: "TextDetail",
  inheritAttrs: false,
  components: {
    RpmReadMore,
    TextAnswer,
    EditorAnswer,
    TextareaAnswer,
  },
  props: {
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    original: {
      type: Object,
      required: true,
    },
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  },
  watch: {
    value(newer){
      this.$emit("update:modelValue", newer);
    }
  }
};
</script>
